import { ServicesContainer } from '@/services';
import { AddToBagEvent } from '@/services/analytics/events/';
import { AnalyticsEventType, AnalyticsMealType, Commerce, ProductFindingMethod } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { ProductListItem } from '../classes/product-list-item';
import { AdobeBaseEvent } from './adobe-base-event';

export class AdobeCartAddEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.AddToBag;
  commerce = { ...this.commerce, productListAdds: { value: 1 } } as Commerce;
  
  constructor(event: AddToBagEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    if (event.meal) {
      this.productListItems = ProductListItem.getProductListItems(event.meal, store, services.order.isDelivery());
    }

    switch (event.mealType) {
      case AnalyticsMealType.Favorite:
        this.commerce.cartAddFavoritedMeal = { value: 1 };
        break;
      case AnalyticsMealType.Recent:
        this.commerce.cartAddRecentMeal = { value: 1 };
        break;
      default:
    }

    switch(event.productFindingMethod) {
      case ProductFindingMethod.Upsell: 
        this.commerce.upsells = { value: 1 };
        this.commerce.upsellAddToBag = { value: 1 };
        this.commerce.pfm = ProductFindingMethod.Upsell;
        break;
      case ProductFindingMethod.AddOn:
        this.commerce.pfm = ProductFindingMethod.AddOn;
        break;
      case ProductFindingMethod.Standalone: 
        this.commerce.pfm = ProductFindingMethod.Standalone;
        break;
    }

    if (event.isPceAddToBag) {
      this.commerce.pceAddToBag = { value: 1 }
    }
  }
} 
